module.exports = __webpack_public_path__ + "img/logo3.35b187a1.png";